import { useTranslation } from 'next-i18next/pages';
import dynamic from 'next/dynamic';
import React, { useCallback } from 'react';

import { ReactComponent as Hyperlink } from '@pflegia/ui/icons/icon-hyperlink.svg';
import { ReactComponent as Facebook } from '@pflegia/ui/icons/icon-social-media-facebook.svg';
import Button from '@pflegia/ui/shared/button';
import ShareOnFacebookButton from '@pflegia/ui/shared/button/ShareOnFacebookButton.component';
import { TOAST_SHORT_LIFETIME, useToast } from '@pflegia/ui/shared/toaster/ToastProvider';

import Section, { SectionTitle } from '../section/Section.component';

const EmailButton = dynamic(() => import('@pflegia/ui/shared/button/EmailButton'), { ssr: false });
const WhatsAppButton = dynamic(() => import('@pflegia/ui/shared/button/WhatsAppButton'), { ssr: false });

interface RecommendationProps {
  formalLanguage?: boolean;
}

const RecommendationComponent: React.FC<RecommendationProps> = ({ formalLanguage = false }) => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'recommendation' });
  const toast = useToast();

  const handleCopyLinkClick = useCallback(() => {
    navigator.clipboard.writeText(window.location.href);
    toast?.success(t('linkCopied'), TOAST_SHORT_LIFETIME);
  }, [t, toast]);

  return (
    <Section className='rounded-2xl bg-white'>
      <SectionTitle t={t} titleKey={formalLanguage ? 'title.formal' : 'title.informal'} />
      <div className='flex flex-col flex-wrap gap-2 sm:flex-row'>
        <WhatsAppButton className='w-full bg-green-400 sm:w-auto' />
        <ShareOnFacebookButton Icon={Facebook} />
        <EmailButton className='w-full bg-blue-700 sm:w-auto' />
        <Button
          data-testid='hyperlink-copy-button'
          label={t('copyLink')}
          className='w-full border border-main-blue bg-white text-main-blue sm:w-auto'
          icon={<Hyperlink />}
          onClick={handleCopyLinkClick}
        />
      </div>
    </Section>
  );
};

export default RecommendationComponent;
